import { render, staticRenderFns } from "./reward-counter.vue?vue&type=template&id=213be2aa&"
import script from "./reward-counter.vue?vue&type=script&lang=js&"
export * from "./reward-counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports